export enum BloodTestTrackingCategory {
    Home = "home",
    InLaboratory = "in_laboratory",
    ResultsReady = "results_ready",
}